import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=3748a92c&scoped=true"
import script from "./BaseDropdown.vue?vue&type=script&lang=ts"
export * from "./BaseDropdown.vue?vue&type=script&lang=ts"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&id=3748a92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3748a92c",
  null
  
)

export default component.exports